import { Field, FieldJump, FieldType } from '@app/api';

export const cleanLogicForField = (field: Field) => {
  if (!field.jumpActions) {
    return field;
  }

  if (
    field.type !== FieldType.SINGLE_CHOICE &&
    field.type !== FieldType.MULTIPLE_CHOICE
  ) {
    return field;
  }
  const choicesRef =
    field.properties.choices?.map((choice) => choice.ref) || [];

  let changed = false;
  const res: FieldJump[] = [];

  for (const jump of field.jumpActions) {
    if (!jump.conditionChoiceRefs) {
      res.push(jump);
      continue;
    }

    const newRefs = jump.conditionChoiceRefs.filter((ref) =>
      choicesRef.includes(ref),
    );
    if (newRefs.length !== jump.conditionChoiceRefs.length) {
      changed = true;
    }
    if (newRefs.length > 0) {
      res.push({
        ...jump,
        conditionChoiceRefs: newRefs,
      });
    }
  }

  if (!changed) {
    return field;
  }
  return {
    ...field,
    jumpActions: res,
  };
};
